import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './assets/css/main.css';
import reportWebVitals from './reportWebVitals';
import Router from './pages/Router';
import LanguageWrapper from './components/LanguageWrapper';
import { configureStores } from './state/store';
import './assets/css/main.css'
import './assets/css/responsive.css'
import './assets/css/aw-settings-themes.css'
// import './assets/css/postcode.css'

// Apply the saved theme, appearance (light/dark/auto) and accent before
// first paint — no wrong-style flash. Auto follows the device's
// prefers-color-scheme and reacts live when it changes.
// Dev aids: ?_theme=apple  ?_scheme=dark  ?_accent=%23e11d48
try {
  const qs = new URLSearchParams(window.location.search);
  let theme = qs.get('_theme') || localStorage.getItem('aw_theme') || 'refined';
  // 'night' is retired: it was a theme, dark is now an appearance setting.
  if (theme === 'night') {
    theme = 'classic';
    try {
      localStorage.setItem('aw_theme', 'classic');
      localStorage.setItem('aw_scheme', 'dark');
    } catch (e) { /* private mode */ }
  }
  document.documentElement.setAttribute('data-aw-theme', theme);

  const darkMedia = window.matchMedia('(prefers-color-scheme: dark)');
  const syncDark = () => {
    const scheme = qs.get('_scheme') || localStorage.getItem('aw_scheme') || 'auto';
    const dark = scheme === 'dark' || (scheme !== 'light' && darkMedia.matches);
    document.documentElement.toggleAttribute('data-aw-dark', dark);
  };
  syncDark();
  if (darkMedia.addEventListener) darkMedia.addEventListener('change', syncDark);

  const accent = qs.get('_accent') || localStorage.getItem('aw_accent');
  if (accent) {
    document.documentElement.style.setProperty('--aw-accent', accent);
    document.documentElement.setAttribute('data-aw-accent', '');
  }

  // Visitor page zoom (A− / A+ next to Settings), saved in aw_zoom.
  const zoom = parseFloat(localStorage.getItem('aw_zoom'));
  if (Number.isFinite(zoom) && zoom !== 1) {
    document.documentElement.style.zoom = String(zoom);
  }
} catch (e) {
  document.documentElement.setAttribute('data-aw-theme', 'refined');
}
const { store, persistor } = configureStores({});
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <LanguageWrapper>
      <Router/>
    </LanguageWrapper>
  </Provider>
  

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
